import React, { useEffect, useState } from "react";
import "../../styles/style.css";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="footer">
        <div className="footer-title">
          <h3>Roadsense (2023)</h3>
          <p>Ateneo de Naga University</p>
        </div>
        <div className="footer-info">
          <Link to="/about">
            About
          </Link>
          <Link to="/help">
            Help
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
